<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="用户名称" prop="user_name">
        <el-input v-model="ruleForm.user_name " />
      </el-form-item>
      <el-form-item label="性别" prop="user_gender">
        <el-select v-model="ruleForm.user_gender">
          <el-option
            v-for="item in userGenderList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户角色" prop="user_roles">
        <el-select v-model="ruleForm.user_roles" multiple>
          <el-option
            v-for="item in roleList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户账号" prop="login_name">
        <el-input v-model="ruleForm.login_name" disabled />
      </el-form-item>
      <el-form-item label="用户电话" prop="mobile">
        <el-input v-model="ruleForm.mobile" />
      </el-form-item>
      <el-form-item label="用户邮箱" prop="mail">
        <el-input v-model="ruleForm.mail" />
      </el-form-item>
      <el-form-item label="用户头像">
        <el-upload
          class="avatar-uploader"
          :action="uploadAction"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="share.head_image" :src="share.head_image" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import RightHelper from '@/api/right_helper'

export default {
  name: '',
  data () {
    return {
      service: 'user',
      id_name: 'user_id',
      imageUrl: '',
      uploadAction: Backend.BACKENDURL + '/admin/upload/head_image',
      userGenderList: BasicDataHelper.UserGenderList,
      share: {
        head_image: undefined
      },
      ruleForm: {},
      rules: {
        user_name: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]{0,25}$/,
            message: '用户名称只能是字母、数字、中文和下划线, 最多25字符'
          }
        ],
        user_roles: [
          { required: true, message: '请选择用户角色', trigger: 'change' }
        ],
        login_name: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_-]{4,20}$/,
            message: '账号的格式为4-20位，只能是字母、数字、下划线、减号'
          }
        ],
        login_pwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          {
            pattern: /^[\w]{6,12}$/,
            message: '密码的格式为6-12位，只能是字母、数字和下划线'
          }
        ],
        mobile: [
          {
            pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^(0|86|17951)?1[3-9][0-9]{9}$)/,
            message: '请输入有效的电话号码'
          }
        ],
        mail: [
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入有效的邮箱地址'
          }
        ]
      }
    }
  },

  props: {
    rowData: {
      default: () => {},
      type: Object
    },
    roleList: {
      default: () => [],
      type: Array
    }
  },

  created () {
    this.getRow(this.rowData)
  },

  methods: {
    getRow (data) {
      for (const k in data) {
        this.$set(this.ruleForm, k, data[k])
      }
      this.ruleForm.user_roles = this.ruleForm.user_roles.map(id => JSON.stringify(id))
      this.ruleForm.head_image = ''
      this.share.head_image = this.ruleForm.head_image_url
    },
    beforeAvatarUpload (file) {
      return RightHelper.beforeHeadImageUpload(this, file, '头像')
    },
    handleAvatarSuccess (res, file) {
      RightHelper.handleLoadSuccess(this, res, file, 'head_image')
    },
    resetForm () {
      this.share.head_image = this.ruleForm.head_image_url
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {
            user_name: '',
            user_gender: '',
            head_image: '',
            user_roles: [],
            mobile: '',
            mail: '',
            user_id: ''
          }
          for (const k in params) {
            params[k] = this.ruleForm[k]
          }
          Backend.editRow(this, params, undefined, '用户管理')
        }
      })
    }
  }
}
</script>
